import { connect } from 'react-redux';

import { getIsWhitelabel } from 'src/store/view/selectors';
import { Preloader } from './Preloader';

const mapStateToProps = () => (state, props: { throbber?: boolean }) => ({
  throbber: props.throbber || getIsWhitelabel(state),
});

export default connect(mapStateToProps)(Preloader);
